import axios from 'axios'
import { Message } from 'element-ui'
// 注意：不在顶层 import store，避免循环依赖链：
//   store/index.js → api/warehouse.js → utils/request.js
// 拦截器直接从 localStorage 读取 currentWarehouseId，
// 与 store 的 SET_CURRENT_WAREHOUSE mutation 保持同步。

const request = axios.create({
    baseURL: '',
    timeout: 10000
})

request.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token
  }

  // 全局仓库选择器：自动注入 warehouseId
  // 排除移库和仓库管理 API
  const url = config.url || ''
  const excludeApis = ['/api/wms/move/', '/api/wms/warehouse/', '/api/wms/inbound-order/production/pending']
  const shouldAddWarehouse = !excludeApis.some(api => url.includes(api))

  if (shouldAddWarehouse) {
    const warehouseId = localStorage.getItem('currentWarehouseId')
    if (warehouseId) {
      if (config.method === 'get') {
        config.params = config.params ? { ...config.params, warehouseId } : { warehouseId }
      } else if (config.method === 'post' || config.method === 'put') {
        // 仅对普通对象注入 warehouseId；FormData 和数组跳过，避免破坏上传数据
        if (config.data && !Array.isArray(config.data) && !(config.data instanceof FormData) && typeof config.data === 'object') {
          config.data = { ...config.data, warehouseId }
        }
      }
    }
  }

  return config
})

request.interceptors.response.use(
    response => {
        // blob 类型（导出文件）直接返回原始数据，不做 JSON 解析
        if (response.config.responseType === 'blob') {
            return response.data
        }
        const res = response.data
        if (res.code !== 200) {
            Message.error(res.message || '错误')
            return Promise.reject(new Error(res.message || 'Error'))
        }
        return res.data
    },
    error => {
        Message.error(error.message || '网络错误')
        return Promise.reject(error)
    }
)

export default request
